import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <InformationalModule
    // configs
    sectionId='sustainability-impact-intro'
    themeType='lightTheme'
    backgroundVariant='lightA'
    moduleName='intro-module'
    moduleVariation='A'
    // content
    headingText={<>Putting people at <WidowBlock>the center</WidowBlock></>}
    introContent={(
      <Typography disableBottomPadding>
        Putting people first is what we do and why we were founded. It drives how we integrate sustainability principles and impact practices into our business, ensuring long&#45;term growth while creating opportunity across generations.
      </Typography>
    )}
  />
);
